import React, { useEffect, useState } from "react";
import AuthContainer from "./AuthContainer";
import CoreH4 from "../../core/dataDisplay/CoreH4";
import { theme } from "../../config/theme";
import { Box } from "@mui/material";
import CoreAlert from "../../core/feedback/CoreAlert";
import CoreInput from "../../core/inputs/CoreInput";

import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_POST } from "../../config/constants";
import {
  DELETE_ACCOUNT_CHECK_ERROR,
  DELETE_ACCOUNT_CHECK_SUCCESS,
  DELETE_ACCOUNT_ERROR,
  DELETE_ACCOUNT_SUCCESS,
} from "../../store/types/authTypes";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import {
  OTP_SENT_ERROR,
  OTP_SENT_SUCCESS,
} from "../../store/types/communicationTypes";
import CoreOtpInput from "../../core/inputs/CoreOtpInput";
import { setAuthReducer } from "../../store/actions/authActions";
import CoreTypographySubtitle2 from "../../core/dataDisplay/CoreTypographySubtitle2";
import CoreTypographyCaption from "../../core/dataDisplay/CoreTypographyCaption";
import { setCommunicationReducer } from "../../store/actions/communicationActions";

export default function DeleteAccount() {
  const dispatch = useDispatch();
  const [emailOrPhone, setEmailOrPhone] = useState(null);
  const [otp, setOtp] = useState(null);

  const deleteAccount = useSelector((state) => state.auth.deleteAccount);
  const checkAccountError = useSelector(
    (state) => state.auth.checkAccountError,
  );
  const checkAccountErrorMsg = useSelector(
    (state) => state.auth.checkAccountErrorMsg,
  );
  const otpSuccess = useSelector((state) => state.communication.sentOtpSuccess);
  const deleteAccountSuccess = useSelector(
    (state) => state.auth.deleteAccountSuccess,
  );
  const deleteAccountError = useSelector(
    (state) => state.auth.deleteAccountError,
  );

  useEffect(() => {
    if (checkAccountError) {
      alert(checkAccountErrorMsg || "Internal error");
    }
    return () => {
      dispatch(
        setAuthReducer({
          deleteAccountLoading: false,
          deleteAccountSuccess: false,
          deleteAccountError: false,
          deleteAccountData: null,
          checkAccountMessage: null,
          checkAccountLoading: false,
          checkAccountSuccess: false,
          checkAccountError: false,
          deleteAccount: null,
        }),
      );
      dispatch(
        setCommunicationReducer({
          sentOtpSuccess: false,
          sentOtpError: false,
          sentOtpMsg: null,
        }),
      );
    };
  }, [checkAccountError]);

  useEffect(() => {
    if (deleteAccountSuccess) {
      dispatch(
        setAuthReducer({
          deleteAccountLoading: false,
          deleteAccountSuccess: false,
          deleteAccountError: false,
          deleteAccountData: null,
          checkAccountMessage: null,
          checkAccountLoading: false,
          checkAccountSuccess: false,
          checkAccountError: false,
          deleteAccount: null,
        }),
      );
      alert("Delete request submitted");
      setEmailOrPhone(null);
      setOtp(null);
    } else if (deleteAccountError) {
      dispatch(
        setAuthReducer({
          deleteAccountLoading: false,
          deleteAccountSuccess: false,
          deleteAccountError: false,
        }),
      );
      alert("Internal error");
    }
  }, [deleteAccountSuccess, deleteAccountError]);

  useEffect(() => {
    if (deleteAccount && !otpSuccess) {
      dispatch(
        api_request(
          API_METHOD_POST,
          "/sentOtp",
          { data: emailOrPhone },
          null,
          null,
          OTP_SENT_SUCCESS,
          OTP_SENT_ERROR,
          false,
          false,
        ),
      );
    }
  }, [deleteAccount]);

  const onSubmit = (e) => {
    e?.preventDefault();
    console.log("Submitting", deleteAccount, otpSuccess);

    if (deleteAccount) {
      if (otpSuccess) {
        dispatch(
          api_request(
            API_METHOD_POST,
            "/account/delete",
            { data: deleteAccount, otp: otp },
            null,
            null,
            DELETE_ACCOUNT_SUCCESS,
            DELETE_ACCOUNT_ERROR,
            false,
            false,
          ),
        );
      }
    } else {
      dispatch(
        api_request(
          API_METHOD_POST,
          "/checkLoginOrRegister",
          {
            emailOrPhone: emailOrPhone,
            onlyCheck: true,
          },
          {},
          null,
          DELETE_ACCOUNT_CHECK_SUCCESS,
          DELETE_ACCOUNT_CHECK_ERROR,
          false,
          false,
        ),
      );
    }
  };

  return (
    <AuthContainer>
      <CoreH4
        style={{
          fontStyle: "italics",
          color: theme.palette.primary.main,
          alignSelf: "baseline",
        }}
      >
        Delete Account
      </CoreH4>
      <Box>
        <CoreAlert severity="warning" icons="warning" variant="filled">
          <CoreTypographyCaption style={{ textAlign: "justify" }}>
            Delete account will delete your account completely. Both app and
            website access will be turned off. Your whole data with DocXplor
            including login info and documents will be completely deleted within
            30 days.
          </CoreTypographyCaption>
        </CoreAlert>

        <form onSubmit={onSubmit}>
          <Box style={{ marginTop: 8, marginBottom: 8 }}>
            <CoreInput
              value={emailOrPhone}
              disabled={deleteAccount}
              onChange={(e) => {
                setEmailOrPhone(e.target.value);
              }}
              autoFocus={true}
              label="Enter email or phone"
            />
            {deleteAccount ? (
              <CoreOtpInput
                value={otp}
                onChange={(value) => {
                  setOtp(value);
                }}
                autoFocus={true}
                label="Enter OTP."
              />
            ) : null}
          </Box>
          <CoreContainedButton fullWidth={true} onClick={onSubmit}>
            {deleteAccount ? "Submit Request" : "Check Account"}
          </CoreContainedButton>
        </form>
      </Box>
    </AuthContainer>
  );
}
